
import { TCypher } from "../../types"
import { get } from "../axiosClient"


type GetCyphersAdminProps = {
    token: string
}

type GetyphersAdminResponse = {
    cyphers?: TCypher[],
    errorMessage?: string
}

export const getCyphersAdmin = async ({ token }: GetCyphersAdminProps): Promise<GetyphersAdminResponse> => {
    return await get({
        params: { },
        path: 'admin/cypher',
        token: token
    }).then((res) => {
        if (res.status === 200) {
            return { cyphers: res.data }
        } else {
            return { errorMessage: res.data }
        }
    });
}